
















import Vue from "vue";
import Component from "vue-class-component";
import { challengesState, challengeModule } from "@/utils/store-acessor";
import { ChallengeModel } from "@/models/challenge.model";
import ChallengesSituationsTemplate from "@/components/Challenges/ChallengesSituationsTemplate.vue";
import NavBar from "@/components/NavBar";

@Component({
  components: {
    NavBar,
    ChallengesSituationsTemplate
  }
})
export default class Challenges extends Vue {
  @challengeModule.Getter("challenges") challenges!: ChallengeModel[];
  @challengeModule.Getter("lastPage") lastPage!: number;
  @challengeModule.Getter("currentPage") page!: number;
  @challengeModule.Getter("loading") loading!: boolean;
  @challengeModule.Getter("challengesByTag") challengesByTag!: (tag: string) => ChallengeModel[];

  get tag(): string | null {
    return this.$route.query?.tag?.toString() || null;
  }

  get emptyMessage(): string {
    return !!this.tag
      ? this.$t("challenge.labels.no_challenges_in_progress_with_tag", [this.tag]).toString()
      : this.$t("challenge.labels.no_challenges_in_progress").toString();
  }

  get challengesFiltered(): ChallengeModel[] {
    return this.challenges;
  }

  async mounted() {
    this.makeRequest(1);
  }

  private async makeRequest(page: number = 1) {
    const tag = this.$route.query?.tag?.toString();
    await challengesState.fetchBySearch({
      page,
      tag
    });
  }
}
